import { createSlice } from "@reduxjs/toolkit";
import {
  AddEmploymentAction,
  DeleteEmploymentAction,
  GetAllEmploymentAction,
  UpdateEmploymentAction,
} from "store/middlewares/dataManagement/employment";

// isDeleteMeFulFilled
export const employmentSlice = createSlice({
  name: "employment",
  initialState: {
    employmentLoading: true,
    employment: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllEmploymentAction.pending, (state) => {
        // state.EmploymentLoading = true;
        // state.Employment = null;
        state.employment =
          state.employment?.data?.length > 0 ? state.employment : null;
      })
      .addCase(GetAllEmploymentAction.fulfilled, (state, action) => {
        state.employmentLoading = false;
        state.employment = action.payload.response;
      })
      .addCase(GetAllEmploymentAction.rejected, (state) => {
        state.employmentLoading = false;
        state.employment = null;
      })
      // Delete
      .addCase(DeleteEmploymentAction.fulfilled, (state, action) => {
        // state.EmploymentLoading = false;
        // state.Employment = {
        //   ...state.Employment,
        //   total: Number(state.Employment.total) - 1,
        //   data: state.Employment?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.employmentLoading = false;
        state.employment = action.payload.response;
      })
      //Update
      .addCase(UpdateEmploymentAction.fulfilled, (state, action) => {
        state.employmentLoading = false;
        state.employment = {
          ...state.employment,
          data: state.employment.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddEmploymentAction.fulfilled, (state, action) => {
        // state.employmentLoading = false;
        // state.employment = {
        //   ...state.employment,
        //   total: Number(state.employment.total) + 1,
        //   data: [action.payload.response, ...state.employment.data],
        // };
        state.employmentLoading = false;
        state.employment = action.payload.response;
      });
  },
});

export default employmentSlice.reducer;
